import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CalloutBox } from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CalloutBox icon="IconInfo" title="Revenue analytics is in beta" type="fyi" mdxType="CalloutBox">
      <p>{`Revenue analytics is currently works best for:`}</p>
      <ol>
        <li parentName="ol">{`Small to medium-sized companies`}</li>
        <li parentName="ol">{`Companies with subscription models (mostly SaaS)`}</li>
      </ol>
      <p>{`If you process more than 20,000 transactions per month, or your revenue comes primarily from one-off payments rather than recurring subscriptions, revenue analytics may feel less useful, slower, or provide less insight than expected.`}</p>
    </CalloutBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      